/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

export const WidgetDateRange = /* @__PURE__ */ zod.object({
    date_from: zod
        .union([zod.enum(['-1M', '-30M', '-1h', '-3h', '-24h', '-7d', '-14d', '-30d', '-90d']), zod.null()])
        .optional(),
})

export type WidgetDateRange = zod.input<typeof WidgetDateRange>
export type WidgetDateRangeOutput = zod.output<typeof WidgetDateRange>
